import { Linking } from "react-native"
import {
  externalDraftQuoteUrl,
  externalNewLoanQuoteUrl,
} from "@/screens/loans/utils/LoanUtils"

/**
 * Open the dashboard's loan inquiry flow in the browser.
 * Replaces the native `/loans/setup` flow for all new quotes.
 */
export const openNewLoanQuote = () => {
  void Linking.openURL(externalNewLoanQuoteUrl())
}

/**
 * Open an unsubmitted draft in the dashboard so it is completed there.
 * Returns false when the draft has no deal id yet, so the caller can fall
 * back to the native wizard rather than opening a broken link.
 */
export const openDraftQuote = (externalLoanId?: string | null): boolean => {
  if (!externalLoanId) {
    return false
  }
  void Linking.openURL(externalDraftQuoteUrl(externalLoanId))
  return true
}
